import React, { memo, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import action from '@flux/action';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import UserGroups from '../projectSetting/groups';

const GroupsDetailForm = (props) => {
  const history = useHistory();
  const groupsFormRef = useRef();
  const {
    steps,
    tranStep,
    saveData,
    memberData,
    clientData,
    groupData,
    saveCreateProjectData,
    changeGroupsDetail,
    changeTeamsDetail,
  } = props;

  async function getAllUser() {
    const pwcTeams = [...new Set(memberData)].filter((member) => member?.email);
    let clients = undefined;
    try {
      clients = clientData?.clientList
        ?.filter((item) => item.email?.trim?.())
        .map((i) => ({ ...i, isClient: true }));
      clients = clients ? clients : [];
    } catch (e) {
      console.log(e);
    }
    return [...pwcTeams, ...clients];
  }

  const onGroupChange = (groupData) => {};

  const onProjectUserChange = (projectUsers = []) => {
    const nextMemberData = [...memberData];
    projectUsers.forEach((user) => {
      if (!user.isClient) {
        const targetUser = nextMemberData.find((i) => user.email === i.email);
        if (targetUser.permission !== user.permission) {
          targetUser.permission = user.permission;
        }
      }
    });
    changeTeamsDetail({ teamMember: nextMemberData });
  };

  const handlePrevious = () => {
    const value = groupsFormRef.current.getData();
    changeGroupsDetail(value);
    saveCreateProjectData({
      ...saveData,
      currentStep: tranStep(steps[0]),
    });
    history.push(`/projects/create/${steps[0]}`);
  };

  const handleSubmit = () => {
    const valid = groupsFormRef.current?.validate();
    if (!valid) {
      return;
    }
    const value = groupsFormRef.current.getData() || [];
    changeGroupsDetail(value);
    const moduleFormData = [...saveData?.customizeModule];
    const { allPureClientGroupIds, allEmptyGroupIds, allGroupIds } =
      value.reduce(
        (accumulator, current) => {
          const groupId = current.groupInfo.id;
          const isPureClientGroup = current.groupMembers.every(
            (i) => i.isClient || i.type === 'Client',
          );
          const isEmptyGroup = current.groupMembers.length === 0;
          accumulator.allGroupIds.push(groupId);
          isEmptyGroup && accumulator.allEmptyGroupIds.push(groupId);
          isPureClientGroup && accumulator.allPureClientGroupIds.push(groupId);
          return accumulator;
        },
        {
          allPureClientGroupIds: [],
          allEmptyGroupIds: [],
          allGroupIds: [],
        },
      );
    moduleFormData.forEach((row, index) => {
      if (!row.groupPermissions) {
        row.groupPermissions = [];
      }
      if (index <= 1) {
        allGroupIds.forEach((id) => {
          const targetPermission = row.groupPermissions.find(
            (i) => i.groupId === id,
          );
          if (!targetPermission) {
            row.groupPermissions.push({
              groupId: id,
              groupPermission: [row.value],
            });
          } else if (!targetPermission?.groupPermission.includes(row.value)) {
            targetPermission.groupPermission.push(row.value);
          }
        });
      } else {
        row.groupPermissions = row.groupPermissions.filter(
          (i) =>
            allGroupIds.includes(i.groupId) &&
            !allEmptyGroupIds.includes(i.groupId),
        );

        const internalValue = row.internalPermissions;
        const clientValue = row.clientPermissions;
        const groupValue = row.groupPermissions || [];
        const groupAllowedValues = groupValue
          .filter((i) => !allPureClientGroupIds.includes(i.groupId))
          .flatMap((i) => i.groupPermission);
        const internalValues = internalValue.map((i) => i.value);
        const allAvailablePermissionKey = [
          ...groupAllowedValues,
          ...internalValues,
        ];

        if (clientValue?.length) {
          row.clientPermissions = clientValue.filter((i) =>
            allAvailablePermissionKey.find((j) => j === i.value),
          );
        }
        groupValue.forEach((i) => {
          i.groupPermission = i.groupPermission.filter((key) =>
            allAvailablePermissionKey.includes(key),
          );
        });
      }
    });

    saveData.customizeModule = moduleFormData;
    saveCreateProjectData({
      ...saveData,
      currentStep: tranStep(steps[1]),
    });
    history.push(`/projects/create/${steps[1]}`);
  };
  const renderAction = () => (
    <div className="form-actions-wrapper setting-btns">
      <Button className="previous-btn" onClick={handlePrevious}>
        previous
      </Button>

      <Button className="ok-btn" onClick={handleSubmit}>
        next
      </Button>
    </div>
  );
  return (
    <UserGroups
      ref={groupsFormRef}
      renderAction={renderAction}
      initialData={groupData}
      getAllUser={getAllUser}
      onGroupChange={onGroupChange}
      onProjectUserChange={onProjectUserChange}
    />
  );
};

const mapStateToProps = ({ projects }) => ({
  clientData: projects.clientData || {},
  groupData: projects.groupData || [],
  memberData: projects.memberData,
  saveData: projects.saveData,
});

const mapDispatchToProps = (dispatch) => ({
  changeGroupsDetail(data) {
    dispatch(action.changeGroupsDetail(data));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  changeTeamsDetail(data) {
    dispatch(action.changeTeamsDetail(data));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(GroupsDetailForm));
